module.exports = __webpack_public_path__ + "static/media/plan-507+508-desktop-sc.2720e55c.png";